import { ensureAffix } from '@helpers/content/ensure-affix';
import { ensureAstralProjector } from '@helpers/content/ensure-astralprojector';
import {
  ensureCaravan,
  ensureCaravanTrader,
} from '@helpers/content/ensure-caravan';
import { ensureCollectibleGate } from '@helpers/content/ensure-collectiblegate';
import { ensureCommissionOffer } from '@helpers/content/ensure-commission';
import { ensureEdict } from '@helpers/content/ensure-edict';
import {
  ensureEncounter,
  ensureEncounterRandom,
} from '@helpers/content/ensure-encounternode';
import { ensureExchangeNode } from '@helpers/content/ensure-exchangenode';
import { ensureGathering } from '@helpers/content/ensure-gathernode';
import { ensureGlobalEffect } from '@helpers/content/ensure-globaleffect';
import {
  ensureCollectible,
  ensureEquipment,
  ensureItem,
} from '@helpers/content/ensure-item';
import { ensureJob } from '@helpers/content/ensure-job';
import { ensureJobAbility } from '@helpers/content/ensure-jobability';
import { ensureMonster } from '@helpers/content/ensure-monster';
import { ensureNodeOverride } from '@helpers/content/ensure-nodeoverride';
import { ensureOutpost } from '@helpers/content/ensure-outpost';
import { ensureRecipe } from '@helpers/content/ensure-recipe';
import { ensureRegion } from '@helpers/content/ensure-region';
import { ensureRumor } from '@helpers/content/ensure-rumor';
import { ensureShrine } from '@helpers/content/ensure-shrine';
import { ensureSkill } from '@helpers/content/ensure-skill';
import { ensureSkillTreeNode } from '@helpers/content/ensure-skilltreenode';
import { ensureStatusEffect } from '@helpers/content/ensure-statuseffect';
import { ensureTask } from '@helpers/content/ensure-task';
import { ensureTown } from '@helpers/content/ensure-town';
import {
  ensureTradeskill,
  ensureTradeskillLevelRequirement,
} from '@helpers/content/ensure-tradeskill';
import {
  ensureTrainer,
  ensureTrainerTeaching,
} from '@helpers/content/ensure-trainer';
import { ensureWorker } from '@helpers/content/ensure-worker';
import type { ContentType, IsContentItem } from '@interfaces';

// eat my ass, typescript
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initializers: Record<ContentType, (entry: any) => any> = {
  affix: ensureAffix,
  astralprojector: ensureAstralProjector,
  caravan: ensureCaravan,
  caravantrader: ensureCaravanTrader,
  collectible: ensureCollectible,
  collectiblegate: ensureCollectibleGate,
  commissionoffer: ensureCommissionOffer,
  edict: ensureEdict,
  encounter: ensureEncounter,
  encounterrandom: ensureEncounterRandom,
  equipment: ensureEquipment,
  exchangenode: ensureExchangeNode,
  gathering: ensureGathering,
  globaleffect: ensureGlobalEffect,
  item: ensureItem,
  job: ensureJob,
  jobability: ensureJobAbility,
  monster: ensureMonster,
  nodeoverride: ensureNodeOverride,
  outpost: ensureOutpost,
  recipe: ensureRecipe,
  region: ensureRegion,
  rumor: ensureRumor,
  shrine: ensureShrine,
  skill: ensureSkill,
  skilltreenode: ensureSkillTreeNode,
  statuseffect: ensureStatusEffect,
  task: ensureTask,
  town: ensureTown,
  tradeskill: ensureTradeskill,
  tradeskilllevelrequirement: ensureTradeskillLevelRequirement,
  trainer: ensureTrainer,
  trainerteaching: ensureTrainerTeaching,
  worker: ensureWorker,
};

export function hasContentInitializer<T extends IsContentItem>(
  content: T,
): boolean {
  return !!initializers[content.__type];
}

export function ensureContent<T extends IsContentItem>(content: T): T {
  return initializers[content.__type](content) satisfies T;
}
